<template>
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.6003 4.43421C15.041 4.01525 15.738 4.02202 16.1705 4.45449C16.603 4.88697 16.6097 5.58397 16.1908 6.02471L16.1705 6.0455L10.216 12L16.1705 17.9545L16.1908 17.9753C16.6097 18.416 16.603 19.113 16.1705 19.5455C15.738 19.978 15.041 19.9847 14.6003 19.5658L14.5795 19.5455L7.8295 12.7955C7.39017 12.3562 7.39017 11.6438 7.8295 11.2045L14.5795 4.45449L14.6003 4.43421Z" />
  </svg>
</template>
